"use client";

import * as React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const partners = [{
  id: 1,
  name: "Saudi Ministry of Tourism",
  role: "Government Authority",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_165515_444.jpg?v=7dz2mc7ywxa"
}, {
  id: 2,
  name: "Silk Road Investment Corp",
  role: "Development Partner",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_172111_420.jpg?v=4bvh3vipitg"
}, {
  id: 3,
  name: "Global Heritage Authority",
  role: "Cultural Preservation",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_171616_282.jpg?v=dt19w3ugyy"
}, {
  id: 4,
  name: "Landmark Developers Group",
  role: "Infrastructure Partner",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_165405_395.jpg?v=zdsqbzj134p"
}, {
  id: 5,
  name: "Euro-Asia Leisure Fund",
  role: "Investment Stakeholder",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_165424_342.jpg?v=ad2uxvunzs"
}, {
  id: 6,
  name: "Coastal Development Board",
  role: "Regional Planning",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_174245_068.jpg?v=jvib9qmv5c"
}, {
  id: 7,
  name: "Horizon Resort Partners",
  role: "Hospitality Management",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_170233_716.jpg?v=vzle8px1zwc"
}, {
  id: 8,
  name: "Metro-Urban Planning Dept",
  role: "Urban Design Advisor",
  logo: "https://perfect-spider.10web.cloud/wp-content/uploads/2026/03/ScreenShot_2026-03-12_172638_236.jpg?v=45i4avfcc9t"
}];
export default function StrategicAlliances() {
  const marqueeItems = [...partners, ...partners];
  return <section data-section-id="104652" id="strategic-alliances" className="w-full py-20 bg-background overflow-hidden border-y border-border/20">
      <style>{`
        @keyframes marquee-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-marquee-scroll {
          animation: marquee-scroll 45s linear infinite;
        }
        .group:hover .animate-marquee-scroll {
          animation-play-state: paused;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6 mb-12 text-center">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-primary tracking-tighter">
          Global Strategic Alliances
        </h2>
        <p className="mt-4 text-foreground/80 max-w-2xl mx-auto text-lg leading-relaxed">
          Partnering with international governments and premier developers to deliver world-class cultural tourism destinations across the Belt and Road initiative.
        </p>
      </div>

      <div className="relative flex overflow-hidden group w-full">
        {}
        <div className="absolute left-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-r from-background to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-24 md:w-48 bg-gradient-to-l from-background to-transparent z-10 pointer-events-none" />

        <div className="flex w-max animate-marquee-scroll items-center py-4">
          {marqueeItems.map((partner, i) => <div key={`${partner.id}-${i}`} data-index={i} className="flex-shrink-0 px-8 md:px-16 flex items-center justify-center">
              <TooltipProvider delayDuration={100}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="cursor-pointer transition-all duration-700 ease-in-out grayscale opacity-50 mix-blend-multiply hover:grayscale-0 hover:opacity-100 hover:scale-105">
                      <img src={partner.logo} alt={`${partner.name} logo`} className="h-10 md:h-16 w-auto object-contain max-w-[200px]" loading="lazy" />
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side="top" align="center" className="mb-2 bg-primary text-primary-foreground border-none rounded-sm px-4 py-2 shadow-xl">
                    <p className="font-bold text-sm tracking-wide">
                      {partner.name}
                    </p>
                    <p className="text-xs opacity-80 mt-0.5 font-mono uppercase tracking-widest">
                      {partner.role}
                    </p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>)}
        </div>
      </div>
    </section>;
}